export const IgnoreKeypress = angular
    .module('checkout.directives.ignoreKeypress', [])
    .directive('ignoreKeypress', () => {
        return {
            restrict: 'A',
            require: '?ignoreKeypressRegex',
            scope: { ignoreKeypressRegex: '=' },
            replace: false,
            link: (scope, element) => {
                element.bind('keypress', (event) => {
                    var regex = new RegExp(scope.ignoreKeypressRegex);
                    var key = String.fromCharCode(!event.keyCode ? event.which : event.keyCode);
                    if (regex.test(key)) {
                        event.preventDefault();
                        return false;
                    }
                });
            }
        };
    }).name;



// WEBPACK FOOTER //
// ./src/app/directives/ignoreKeypress.js